import styled, { keyframes } from 'styled-components';

import { Theme } from 'styles/DefaultTheme';

interface ISkeletonBox {
	_width: string;
	_height: string;
	radius?: string;
	delay?: string;
	_margin?: string;
}

const CoreSkeletonBox = ({ _width, _height, radius, delay, _margin }: ISkeletonBox) => {
	return (
		<Box
			_width={_width}
			_height={_height}
			radius={radius}
			delay={delay}
			_margin={_margin}
		/>
	);
};

const skeleton_ani = keyframes`
    0% {
      background-color: ${Theme.colors.uplus.bg10_lighten};
    }
    50% {
      background-color: ${Theme.colors.uplus.bg20};
    }
    100% {
      background-color: ${Theme.colors.uplus.bg10_lighten};
    }
`;

const Box = styled.div<{
	_width: string;
	_height: string;
	radius?: string;
	_margin?: string;
	delay?: string;
}>`
	width: ${({ _width }) => _width};
	height: ${({ _height }) => _height};
	flex-shrink: 0;
	${({ radius }) => radius && `border-radius: ${radius}`};
	${({ _margin }) => _margin && `margin: ${_margin}`};
	background-color: ${Theme.colors.uplus.bg10_lighten};
	animation: ${skeleton_ani} 2s infinite ease-in-out;
	${({ delay }) => delay && `animation-delay: ${delay}`};
`;

export default CoreSkeletonBox;
